module.exports = __webpack_public_path__ + "static/media/spphotonic-darktheme.455667d1.jpg";